export default __webpack_public_path__ + "static/media/Simple-Portfolio-website.755acc37.png";